import React from 'react';
import { MapIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import amesLogo from '../assets/ames-logo.svg';

function Footer({ onDemoRequest }) {
  return (
    <footer id="contact" className="bg-white text-gray-800 py-12 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="flex items-center mb-4">
          
              <div className="flex items-center justify-center">
            <img
              src={amesLogo}
              alt="Ames Engineering Logo"
              className="h-14 w-auto bg-white p-2 rounded"
            />
          </div>
            </div>
            <p className="text-gray-800 max-w-md mb-6 leading-tight">
              Enterprise road profiling platform trusted by transportation agencies and engineering firms nationwide. 
              Complete vehicle integration and professional implementation included.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-gray-800">
                <PhoneIcon className="h-4 w-4 mr-2" />
                <span>515-292-8194</span>
              </div>
              <div className="flex items-center text-gray-800">
                <EnvelopeIcon className="h-4 w-4 mr-2" />
                <span>sales@amesengineering.com</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Products</h4>
            <ul className="space-y-2 text-gray-800">
              <li><a href="https://www.amesengineering.com/all-products" className="hover:text-red-600 transition-colors">All Products</a></li>
              <li><a href="https://www.amesengineering.com/products/software-data-analysis" className="hover:text-red-600 transition-colors">Software & Data Analysis</a></li>
              <li><a href="https://www.amesengineering.com/resources/inertial-road-profilers-faq" className="hover:text-red-600 transition-colors">Profiler FAQ</a></li>
              <li><a href="https://www.amesengineering.com/support" className="hover:text-red-600 transition-colors">Support</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-800">
              <li><a href="https://www.amesengineering.com/about" className="hover:text-red-600 transition-colors">About Ames</a></li>
              <li><a href="https://www.amesengineering.com/sales/salesRequest" className="hover:text-red-600 transition-colors">Contact Sales</a></li>
              <li><a href="https://www.amesengineering.com/contact" className="hover:text-red-600 transition-colors">Contact Us</a></li>
              <li><a href="https://www.amesengineering.com/resources" className="hover:text-red-600 transition-colors">Resources</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-12 pt-8 text-center text-gray-800">
          <p>&copy; 2025 Ames Engineering. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;